<template>
  <div class="page-content realNameAuth disabled" :style="defaultHeight">
    <div class="startTitle">专家入驻</div>
    <el-row>
      <el-col :span="16" :offset="4">
        <ul class="stepBox">
          <li class="stepText">
            <img src="../../assets/images/back/step.png" alt="">
            <span class="act">实名认证</span>
          </li>
          <li class="stepLine"></li>
          <li class="stepText">
            <img src="../../assets/images/back/stepno.png" alt="">
            <span class="">简介</span>
          </li>
          <li class="stepLine "></li>
          <li class="stepText">
            <img src="../../assets/images/back/stepno.png" alt="">
            <span class="">提交审核</span>
          </li>
        </ul>
      </el-col>
    </el-row>
    <el-row style="margin-top: 30px">
      <el-col :span="14" :offset="5">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="真实姓名" prop="name" :disabled="isDisabled">
            <el-input v-model="ruleForm.name" :disabled="isDisabled"></el-input>
          </el-form-item>
          <el-form-item label="证件类型" prop="idType">
            <el-select :disabled="isDisabled" v-model="ruleForm.idType" placeholder="请选择" style="width: 170px">
              <el-option label="身份证" value="1"></el-option>
              <el-option label="军官证" value="2"></el-option>
              <el-option label="台胞证" value="3"></el-option>
              <el-option label="护照" value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证件号码" prop="idNumber">
            <el-input :disabled="isDisabled" v-model="ruleForm.idNumber"></el-input>
          </el-form-item>
          <el-form-item class="idImgBox" label="证件照片" required style="margin-bottom: 0">
            <el-col :span="11">
              <el-form-item prop="credenPhotofront">
                <div class="credenPhoto">

                  <el-upload :disabled="isDisabled" class="btn-plus" :action="imgAction" :http-request="front_uploadImg" name="img" :multiple="false" :show-file-list="false" :on-success="front_handleSuccess" :before-upload="beforeUpload">
                    <img v-if="ruleForm.credenPhotofront" :src="ruleForm.credenPhotofront" class="imgsrcval">
                    <div v-else>
                      <img src="../../assets/images/back/credenPhotofront.png" alt="">
                      <el-button icon="el-icon-plus" circle></el-button>
                    </div>
                    <p class="idbottom_Text">上传身份证人像面</p>
                  </el-upload>

                </div>
              </el-form-item>
            </el-col>
            <el-col class="line" :span="2" style="color: #ffffff">-</el-col>
            <el-col :span="11">
              <el-form-item prop="credenPhotoback">
                <div class="credenPhoto">
                  <el-upload :disabled="isDisabled" class="btn-plus" :action="imgAction" :http-request="back_uploadImg" name="img" :multiple="false" :show-file-list="false" :on-success="back_handleSuccess" :before-upload="beforeUpload">
                    <img v-if="ruleForm.credenPhotoback" :src="ruleForm.credenPhotoback" class="imgsrcval">
                    <div v-else>
                      <img src="../../assets/images/back/credenPhotoback.png" alt="">
                      <el-button icon="el-icon-plus" circle></el-button>
                    </div>
                    <p class="idbottom_Text">上传身份证国徽面</p>
                  </el-upload>
                </div>
              </el-form-item>
            </el-col>
          </el-form-item>
          <div class="el-upload__tip" style="padding-left: 100px;padding-top: 5px;padding-bottom: 10px">请使用jpg格式照片，大小不超过5M</div>
          <el-form-item>
            <el-button type="success" class="btn-save dmh-colbtn" @click="submitForm('ruleForm')">下一步</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import '@/assets/css/backcommon.css'
import Cookies from 'js-cookie'
import { Notification } from 'element-ui'
import { professionalSettleIn, professionalQueryRealById, professionalSaveRealName, uploadImg } from '@/api/myInfo'
import baseAPI from "@/api/baseAPI";
export default {
  name: "zizhiAuthZj_smrz",
  data () {
    return {
      isDisabled: false,
      defaultHeight: {
        height: ""
      },
      //图片列表（用于在上传组件中回显图片）
      fileList: [],
      // 图片上传地址
      imgAction: null,
      //审核失败  修改
      isModifyData: false,
      userId: '',
      ruleForm: {
        name: '',
        idType: '',
        idNumber: '',
        credenPhotofront: '',
        credenPhotoback: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' },
        ],
        idType: [
          { required: true, message: '请选择证件类型', trigger: 'change' }
        ],
        idNumber: [
          { required: true, message: '请输入证件号码', trigger: 'blur' },
        ],
        credenPhotofront: [
          { required: true, message: '请选择上传身份证正面' },
        ],
        credenPhotoback: [
          { required: true, message: '请选择上传身份证反面' },
        ],
      }
    }
  },
  components: {},
  beforeMount () {
    this.userId = this.$store.state.user.userId;
    if (this.userId === "") {
      this.userId = JSON.parse(Cookies.get("userInfo"))["userId"];
    }
    var isModifyData = this.$route.query.isModifyData;
    console.log(isModifyData);
    if (isModifyData == undefined) {
      this.isModifyData = "false";
    } else {
      this.isModifyData = "true";
    }
    this.getImgAction();
    this.professionalSettleIn();

  },
  mounted () {

    //页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
    // window.addEventListener("resize", this.getHeight);
    // this.getHeight();

  },
  methods: {
    getHeight () {
      this.defaultHeight.height = window.innerHeight - 105 + "px";
    },
    professionalQueryRealById () {
      var ths = this;
      professionalQueryRealById(this.userId).then(res => {
        console.log(res);
        if (parseFloat(res.data.code) === 200) {
          if (res.data.data === "") {
            if (ths.isModifyData === "false") {
              ths.isDisabled = false;
            }
            return;
          }
          var data = res.data.data;
          ths.setData(ths, data);
          if (ths.isModifyData === "false") {
            ths.isDisabled = true;
          }
        } else {
          this.message(res.data.msg);
        }
      });
    },
    setData (ths, data) {
      ths.ruleForm = {
        name: data.realName,
        idType: data.cardType,
        idNumber: data.cardId,
        credenPhotofront: data.cardImagePositive,
        credenPhotoback: data.cardImageBack,
      };
    },
    professionalSettleIn () {
      var ths = this;
      professionalSettleIn(this.userId).then(res => {
        if (parseFloat(res.data.code) === 200) {
          //是否已经提交
          if (res.data.data === "" || res.data.data === undefined || res.data.data === null) {//填写审核信息ok
            ths.professionalQueryRealById();
            return;
          } else if (parseInt(res.data.data.status) === 0) {//审核中ok
            ths.$router.replace('/personCenter/zizhiAuth/zj_submitShenhe');
          } else if (parseInt(res.data.data) === 1) {//  审核成功 ok
            //ths.message("审核已通过");
            //ths.setData(ths,res.data.data);
            ths.$router.replace('/personCenter/zizhiAuth/zj_submitShenhe');
          } else if (parseInt(res.data.data.status) === 2) {//审核失败 ok
            if (this.isModifyData == "false") {
              ths.$router.replace('/personCenter/zizhiAuth/zj_submitShenhe');
              return;
            }
            ths.message("审核未通过,请重新填写信息");
            //需要修改true就回显数据
            ths.professionalQueryRealById();
            ths.setData(ths, res.data.data);
          } else {

          }
        } else {
          this.message(res.data.msg);
        }
      });
    },


    submitAjax () {
      var this_ = this;
      var data = {
        realName: this.ruleForm.name,
        cardId: this.ruleForm.idNumber,
        cardType: this.ruleForm.idType,
        cardImagePositive: this.ruleForm.credenPhotofront,
        cardImageBack: this.ruleForm.credenPhotoback
      };
      professionalSaveRealName(data).then(res => {
        if (parseFloat(res.data.code) === 200) {
          this.message("提交成功", 'success');
        } else if (parseFloat(res.data.code) === 500) {
          this.message(res.data.msg);
        }
        setTimeout(() => {
          var str = '';
          if (this.isModifyData === "true") {
            str = "?isModifyData=true"
          }
          this_.$router.push("/personCenter/zizhiAuth/zizhiAuthZj_jianjie" + str);
        }, 1500);
      });
    },

    submitForm (formName) {
      var this_ = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          /*this_.$router.push("/personCenter/zizhiAuth/zizhiAuthZj_jianjie");
          return ;*/
          this_.submitAjax();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 赋值文件上传路径
    getImgAction () {
      let _this = this;
      // _this.imgAction = process.env.VUE_APP_BASE_API + '/device/product/uploadImg';
      _this.imgAction = baseAPI + '/device/product/uploadImg';
    },
    front_handleSuccess (res, file) {
      this.$message({
        type: 'info',
        message: '身份证人像面图片上传成功',
        duration: 6000
      });
    },
    back_handleSuccess (res, file) {
      this.$message({
        type: 'info',
        message: '身份证国徽面图片上传成功',
        duration: 6000
      });
    },
    beforeUpload (file) {
      const isJPG = file.type === 'image/jpeg';
      const isGIF = file.type === 'image/gif';
      const isPNG = file.type === 'image/png';
      const isBMP = file.type === 'image/bmp';
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isJPG && !isGIF && !isPNG && !isBMP) {
        this.$message.error('上传图片必须是JPG/GIF/PNG/BMP 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return (isJPG || isBMP || isGIF || isPNG) && isLt2M;
    },
    front_uploadImg (query) {
      let ths = this;
      let param = new FormData();
      param.append('img', query.file);
      uploadImg(param).then(response => {
        console.log(response.data.data);
        if (parseInt(response.data.code) === 200) {
          ths.ruleForm.credenPhotofront = response.data.data; //将返回的文件储存路径赋值picture字段
          // this.form.projectContractName = response.fileName;
          Notification({
            title: response.data.msg,
            type: 'success'
          });
        }
      })
    },
    back_uploadImg (query) {
      let ths = this;
      let param = new FormData();
      param.append('img', query.file);
      uploadImg(param).then(response => {
        console.log(response.data.data);
        if (parseInt(response.data.code) === 200) {
          ths.ruleForm.credenPhotoback = response.data.data; //将返回的文件储存路径赋值picture字段
          // this.form.projectContractName = response.fileName;
          Notification({
            title: response.data.msg,
            type: 'success'
          });
        }
      })
    },
  },
}
</script>

<style scoped>
.credenPhoto {
  position: relative;
  width: 240px;
  height: 170px;
  /*border: 1px dashed #93A5BD;*/
}
.credenPhoto img {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.credenPhoto img.imgsrcval {
  position: relative;
  left: 0;
  top: 0;
  width: 100%;
  height: 170px;
}
.btn-plus {
  display: block;
  margin: 0 auto;
  text-align: center;
  line-height: 170px;
}
.btn-plus .el-button {
  border: 2px solid #000000;
  position: relative;
}
.idbottom_Text {
  padding-top: 10px;
  font-size: 14px;
  text-align: center;
  font-weight: 600;
  color: rgba(101, 101, 101, 1);
  line-height: 2;
}
.realNameAuth .idImgBox > .el-form-item__content {
  padding-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/personCenter/zizhiAuthZj_smrz.vue